/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app  = require('mag-app'),

    Page = require('stb-component-page'),

    page = new Page({
        $node: document.getElementById('pageMain')
    });


core.addListener('hide', function () {
    if ( app.visible ) {
        core.call('hide');
    }
    app.visible = false;
    app.notifyWidget.hide();
});


window.top.document.body.onoffline = document.body.ononline = function () {
    if ( navigator.onLine ) {
        app.notifyWidget.init({
            title: gettext('The network cable is connected'),
            icon: 'alert',
            type: 'warning'
        });
    } else {
        app.notifyWidget.init({
            title: gettext('The network cable is disconnected'),
            icon: 'alert',
            type: 'warning',
            buttons: [
                {
                    value: gettext('Ok')
                }
            ]
        });
    }
};


// public
module.exports = page;
